import { Box } from '@zillow/constellation-10';

import { LoadingHeading } from '@zg-rentals/loading-components';
import { UpcomingTours } from '@zg-rentals/touring';
import { useZCalendarWebApiHandler_getTouringTreatmentForZuidAndListing } from '@zg-rentals/ts-z-calendar-client-react-query';

import { useScreenSize } from '../../../../hooks/useScreenSize';

import TouringPropertyDashboardCSEvents from '../../../../../srcLegacy/shared/model/ClickstreamEvent/Touring/TouringPropertyDashboardCSEvents';
import { getTourCalendarRoute } from '../../../../constants/urls';

import ConnectedModuleCard from '../../../../../srcLegacy/shared/components/ConnectedModuleCard';
import { useAuth } from '../../../../components/AuthProvider';

type Props = {
  listingAlias: string;
  isActive: boolean;
};

const UpcomingToursModule = ({ listingAlias, isActive }: Props) => {
  const { user } = useAuth();
  const { isScreenMobile } = useScreenSize();

  const inquiriesPath = `/rental-manager/lead-management/${listingAlias}`;
  const { pathname: tourCalendarPathname } = getTourCalendarRoute({ listingAlias });
  const tourCalendarPath = `/rental-manager${tourCalendarPathname.replace('[listingAlias]', listingAlias)}`;

  const { data: touringTreatment, isLoading: isGetTouringTreatmentLoading } =
    useZCalendarWebApiHandler_getTouringTreatmentForZuidAndListing(
      { listingAlias },
      { enabled: Boolean(listingAlias) },
    );

  const onCalendarClick = () => {
    if (user) {
      TouringPropertyDashboardCSEvents.UpcomingToursMoreToursCta({ currentProperty: { listingAlias }, user });
    }
  };

  return (
    <>
      {isGetTouringTreatmentLoading ? (
        <Box css={{ marginBottom: '400' }}>
          <ConnectedModuleCard
            isLoading={isGetTouringTreatmentLoading}
            css={{
              borderRadius: { base: 0, xxl: 'Card.Root' },
            }}
          >
            <LoadingHeading level={2} isLoading={isGetTouringTreatmentLoading} loadingWidth="100%">
              Upcoming Tours
            </LoadingHeading>
          </ConnectedModuleCard>
        </Box>
      ) : (
        touringTreatment &&
        touringTreatment.isTouringEnabledForListing &&
        (isActive || touringTreatment.hasBookedTours) && (
          <Box css={{ marginBottom: '400' }}>
            <ConnectedModuleCard
              css={{
                borderRadius: { base: 0, xxl: 'Card.Root' },
              }}
            >
              <UpcomingTours
                inquiriesPath={inquiriesPath}
                isScreenMobile={isScreenMobile}
                listingAlias={listingAlias}
                onCalendarClick={onCalendarClick}
                tourCalendarPath={tourCalendarPath}
                eventId={TouringPropertyDashboardCSEvents.UpcomingToursMoreToursCta.data_event_id}
              />
            </ConnectedModuleCard>
          </Box>
        )
      )}
    </>
  );
};

export default UpcomingToursModule;
